function getRaceStartTime(race) {
  const startTime = new Date(race?.raceInfo?.raceDateStart).getTime();
  return Number.isFinite(startTime) ? startTime : 0;
}

export function getLocalTodayKey(now, timeZone = "") {
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  try {
    return new Intl.DateTimeFormat("en-CA", {
      ...options,
      ...(timeZone ? {timeZone} : {}),
    }).format(new Date(now));
  } catch (_error) {
    return new Intl.DateTimeFormat("en-CA", options).format(new Date(now));
  }
}

function sortRacesByStartDateDesc(a, b) {
  const startDiff = getRaceStartTime(b) - getRaceStartTime(a);
  if (startDiff !== 0) {
    return startDiff;
  }

  const nameDiff = (a?.raceInfo?.name || "").localeCompare(b?.raceInfo?.name || "");
  if (nameDiff !== 0) {
    return nameDiff;
  }

  return (a?.raceInfo?.legName || "").localeCompare(b?.raceInfo?.legName || "");
}

export function groupChallengesByStatus(userRaces, now = Date.now(), timeZone = "") {
  const groupedChallenges = {
    current: [],
    finished: [],
    concluded: [],
  };

  if (!userRaces) {
    return groupedChallenges;
  }

  userRaces.forEach((race) => {
    const isFinished = Boolean(race?.completedDate);
    const localDatePolicy = race?.raceInfo?.activityDatePolicy === "participant_local_v1";
    const endTime = new Date(race?.raceInfo?.raceDateEnd).getTime();
    const todayKey = getLocalTodayKey(now, timeZone);
    const endDayKey = localDatePolicy
      ? race?.raceInfo?.activityEndDate
      : null;
    const isConcluded = localDatePolicy
      ? Boolean(endDayKey && todayKey > endDayKey)
      : Number.isFinite(endTime) && endTime < now;

    if (isFinished) {
      groupedChallenges.finished.push(race);
      return;
    }

    if (isConcluded) {
      groupedChallenges.concluded.push(race);
      return;
    }

    groupedChallenges.current.push(race);
  });

  Object.values(groupedChallenges).forEach((races) => races.sort(sortRacesByStartDateDesc));

  return groupedChallenges;
}
